import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {ViewProperNounHints} from "../Elements/AscElements/ProperNounElements";


export default class ProperNounReadModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.ProperNounInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <ViewProperNounHints
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewProperNounHints>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

ProperNounReadModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
